module.exports = __webpack_public_path__ + "img/cloud_load.8ee212da.gif";